import { Card, Col, Row } from "react-bootstrap";

import React from "react";
import { useTranslation } from "react-i18next";
import { formatDateFull } from "../../../utils";

const FormSystemInformation = (props) => {
  const { t } = useTranslation();
  const { data } = props || {};

  return (
    <Card>
      <Card.Header>{t(`global.systemInfo`)}</Card.Header>
      <Card.Body>
        <Row>
          <Col lg={12} className="mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="system-information-key">
                {t(`global.createdAt`)}:
              </div>
              <div className="system-information-value">
                {formatDateFull(data.createdAt)}
              </div>
            </div>
          </Col>
          <Col lg={12} className="mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="system-information-key">
                {t(`global.updatedAt`)}:
              </div>
              <div className="system-information-value">
                {formatDateFull(data.updatedAt)}
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FormSystemInformation;
